/**
 *   Created by wangyuelong on 2018/5/8
 */
// @flow
// import _ from 'lodash';
import qs from 'query-string';
import isomorphicConfig from '../utility/isomorphicConfig';
const errorFilter = ["Failed to execute 'postMessage' on 'Window'", 'className.indexOf is not a function'];
const stringifyStack = (error) => {
  if (!error || !error.stack) {
    return error;
  }
  let stack = error.stack
    .replace(/\n/gi, '')
    .split(/\bat\b/)
    .slice(0, 5)
    .join('@')
    .replace(/\?[^:]+/gi, '');
  const msg = error.toString();
  if (stack.indexOf(msg) < 0) {
    stack = `${msg}@${stack}`;
  }
  return stack;
};

/**
 * js报错上报
 * @param  {Element} error
 */
export default ({
  message = '',
  filename = '',
  lineno = 0,
  colno = 0,
  error,
}: {
  message?: *,
  filename?: string,
  lineno?: number,
  colno?: number,
  error?: Error,
}) => {
  const stack = stringifyStack(error);
  const msg = typeof message === 'string' ? message : JSON.stringify(message) || '';
  const isFilter = errorFilter.some((words) => msg.indexOf(words) > -1);
  if (isFilter) {
    return;
  }
  const body = {
    message: msg,
    filename,
    lineno,
    colno,
    stack,
    x5Report: '0',
  };
  // 添加内核X5BadJsReporter上报
  /* const badReporter = _.get(window, 'X5BadJsReporter.report');
  if (badReporter && typeof badReporter === 'function') {
    body.x5Report = '1';
    badReporter('newsnodeHtml', filename, qs.stringify(body));
  } */
  new window.Image().src = `${isomorphicConfig.newsHost || ''}/api/error?__=${window.btoa(qs.stringify(body))}`;
};
